import { z } from "zod";
import { PLAYTHROUGH_STATUS_VALUES } from "../../constants/playthrough-status.js";
import { PlaybackProgressSchema } from "./progress.js";
import { UnlockedEndingSchema } from "./unlocked-ending.js";
export const startPlaythroughSchema = z.object({
    storyId: z.uuid(),
});
export const recordChoiceSchema = z.object({
    playthroughId: z.uuid(),
    decisionId: z.uuid(),
    choiceId: z.uuid(),
});
export const completePlaythroughSchema = z.object({
    playthroughId: z.uuid(),
});
export const PlaythroughSchema = z.object({
    id: z.uuid(),
    storyId: z.uuid(),
    status: z.enum(PLAYTHROUGH_STATUS_VALUES),
    currentNodeId: z.uuid(),
    progress: PlaybackProgressSchema,
    startedAt: z.string(),
});
export const PlaythroughResultSchema = z.object({
    playthrough: PlaythroughSchema,
    unlockedEnding: UnlockedEndingSchema,
});
